<form nz-form>

  <div class="card-container m-b-20">

    <div class="card-head flex flex-horiz-space-bw">
      <h3 class="card-summary-title"><i nz-icon nzType="user"></i> Product and Plan</h3>
      <div>
        <nz-button-group>
          <button *ngIf="!cardCollapsed" nz-button class="b-0" (click)="cardCollapsed=!cardCollapsed"><i nz-icon nzType="edit"></i>Edit</button>
          <!-- <nz-dropdown-button (nzClick)="console.log('ddKlic')" class="b-0">
            Add
            <ul nz-menu>
              <li nz-menu-item>Add New</li>
              <li nz-menu-item>Search</li>
            </ul>
          </nz-dropdown-button>-->
        </nz-button-group>
      </div>
    </div>

    <div class="card-summary" *ngIf="!cardCollapsed">
      <div class="card-summary-content">
        <div class="card-summary-data-grid">
          <div class="card-summary-data">
            <b>Product:</b>
            <!--<nz-avatar nzIcon="user" nzSrc="https://randomuser.me/api/portraits/women/17.jpg"></nz-avatar>-->
            HealthFirst
          </div>
          <div class="card-summary-data">
            <b>Plan:</b> Silver
          </div>
          <!-- <div class="card-summary-data">
            <b>Currency:</b> BMW
          </div> -->
          <div class="card-summary-data">
            <b>Purpose of Insurance:</b> Protection
          </div>
          <!-- <div class="card-summary-data">
            <b>Entry Date:</b> Sep 4, 2019
          </div> -->
          <!-- <div class="card-summary-data">
            <b>Received Date:</b> Sep 4, 2019
          </div> -->
          <!-- <div class="card-summary-data">
            <b>Signed Date:</b> Sep 4, 2019
          </div> -->
          <div class="card-summary-data">
            <b>Inception Date:</b> Sep 4, 2019
          </div>
          <div class="card-summary-data">
            <b>Expiry Date:</b> Sep 4, 2019
          </div>
          <!-- <div class="card-summary-data">
            <b>Due Date:</b> Sep 4, 2019
          </div> -->

          <!-- <div class="card-summary-data">
            <b>Summary:</b> Yes
          </div> -->
        </div>
      </div>
      <!-- <div class="card-summary-actions">
        <a href="javascript:void(0)" (click)="cardCollapsed=!cardCollapsed">
          <i nz-icon nzType="edit"></i>
        </a>
      </div> -->
    </div>

    <form *ngIf="cardCollapsed">
      <div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Product</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                <nz-option nzValue="1" nzLabel="HealthFirst"></nz-option>
                <nz-option nzValue="0" nzLabel="HealthSecond"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Plan</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                <nz-option nzValue="1" nzLabel="Gold"></nz-option>
                <nz-option nzValue="0" nzLabel="Silver"></nz-option>
                <nz-option nzValue="0" nzLabel="Platinum"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <!-- <nz-form-item>
                  <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                      <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                          <nz-option nzValue="1" nzLabel="Protection"></nz-option>
                          <nz-option nzValue="0" nzLabel="Credit Terms"></nz-option>
                      </nz-select>
                  </nz-form-control>
              </nz-form-item> -->
          <div></div>

        </div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio nzValue="A">Protection</label>
                <label nz-radio nzValue="B">Credit Terms</label>
                <label nz-radio nzValue="C">Safety and Convinience</label>
                <label nz-radio nzValue="D">Others</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Currency</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio nzValue="A">USD</label>
                <label nz-radio nzValue="B">INR</label>
                <label nz-radio nzValue="C">IDR</label>
                <label nz-radio nzValue="D">SGD</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>


        <div class="flexie-auto-grid">

          <!-- <nz-form-item>
                <nz-form-label [nzSpan]="24">Currency</nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                        <nz-option nzValue="1" nzLabel="USD"></nz-option>
                        <nz-option nzValue="0" nzLabel="INR"></nz-option>
                        <nz-option nzValue="0" nzLabel="IDR"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item> -->

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Inception Date and Expiry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-range-picker name="daterange" [(ngModel)]="dateRange" (ngModelChange)="onChange($event)" nzShowTime></nz-range-picker>
            </nz-form-control>
          </nz-form-item>
          <div></div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Due Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>



        </div>

        <div class="flexie-auto-grid">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Entry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Received Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Signed Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

        </div>

      </div>
      <div class="card-summary-data-footer">
        <div>
          <button nz-button (click)="cardCollapsed=!cardCollapsed">Cancel</button>
        </div>
        <div>
          <button nz-button class="b-0 m-r-10" (click)="cardCollapsed=!cardCollapsed">Cancel</button>
          <button nz-button [nzType]="'primary'" (click)="cardCollapsed=!cardCollapsed">Save</button>
        </div>
      </div>
    </form>

  </div>

  <div class="card-container m-b-20">
    <div class="card-head flex flex-horiz-space-bw">
      <h3 class="card-summary-title"><i nz-icon nzType="user"></i> Insured</h3>
      <div>
        <nz-button-group>
          <!-- <button nz-button class="b-0"><i nz-icon nzType="edit"></i>Edit</button>  -->
          <!-- <nz-dropdown-button class="b-0">
            Add
            <ul nz-menu>
              <li (click)="showClientCaptureModalMiddle()" nz-menu-item>Add New Client</li>
              <li (click)="showModalMiddle()" nz-menu-item>Search Client</li>
            </ul>
          </nz-dropdown-button> -->
        </nz-button-group>
      </div>
    </div>

    <div class="card-summary" *ngIf="!insuredCardCollapsed">
      <div class="card-summary-content">
        <nz-list *ngIf="insureddata != null" [nzDataSource]="insureddata" [nzRenderItem]="item" [nzGrid]="{gutter: 16, span: 6}">
          <ng-template #item let-item>
            <nz-list-item [nzContent]="nzContent">
              <ng-template #nzContent>
                <nz-card [nzTitle]="item.title">
                  {{item.name}}
                </nz-card>
              </ng-template>
            </nz-list-item>
          </ng-template>
        </nz-list>

        <div *ngIf="insureddata === null || (insureddata != null && insureddata.length === 0)">

          <div class="flexie-auto-grid">
            <div>
              <div class="zero-ui">
                <div class="flexie-auto-grid">
                  <div (click)="showClientCaptureModalMiddle()" class="zero-ui-clickable">
                    <i nz-icon nzType="schedule" nzTheme="outline"></i>
                    <h2>Add new client</h2>
                    <p>Click here to add new insured members for this proposal</p>
                  </div>
                  <div (click)="showModalMiddle()" class="zero-ui-clickable">
                    <i nz-icon nzType="team" nzTheme="outline"></i>
                    <h2>Search clients</h2>
                    <p>Click here to search existing clients for this proposal</p>
                  </div>
                </div>
              </div>

            </div>

          </div>



        </div>
      </div>
      <!-- <div class="card-summary-actions">
        <a href="javascript:void(0)" (click)="insuredCardCollapsed=!insuredCardCollapsed">
          <i nz-icon nzType="edit"></i>
        </a>
      </div> -->
    </div>

    <div *ngIf="insuredCardCollapsed">

      <div class="card-summary-data-footer">
        <div>
          <button nz-button (click)="insuredCardCollapsed=!insuredCardCollapsed">Cancel</button>
        </div>
        <div>
          <button nz-button class="b-0 m-r-10" (click)="insuredCardCollapsed=!insuredCardCollapsed">Cancel</button>
          <button nz-button [nzType]="'primary'" (click)="insuredCardCollapsed=!insuredCardCollapsed">Save</button>
        </div>
      </div>
    </div>

  </div>

  <div class="card-container m-b-20">

    <h3 class="card-summary-title"><i nz-icon nzType="user"></i> Coverages</h3>

    <div class="card-summary" *ngIf="!coverageCardCollapsed">
      <div class="card-summary-content">
        <nz-list [nzDataSource]="data" nzBordered nzSize="small" [nzRenderItem]="item">
          <ng-template #item let-item>
            <nz-list-item [nzContent]="item"></nz-list-item>
          </ng-template>
        </nz-list>
      </div>
      <div class="card-summary-actions">
        <a href="javascript:void(0)" (click)="coverageCardCollapsed=!coverageCardCollapsed">
          <i nz-icon nzType="edit"></i>
          <!--[ edit ]-->
        </a>
      </div>
    </div>

    <div *ngIf="coverageCardCollapsed">
      <div>

        <div class="flexie-auto-grid">
          <div>

            <div class="zero-ui">
              <i nz-icon nzType="bars" nzTheme="outline"></i>
              <h2>Add Coverage</h2>
              <p>Click here to add additional coverages</p>
            </div>

          </div>

        </div>



      </div>
      <div class="card-summary-data-footer">
        <div>
          <button nz-button (click)="coverageCardCollapsed=!coverageCardCollapsed">Cancel</button>
        </div>
        <div>
          <button nz-button class="b-0 m-r-10" (click)="coverageCardCollapsed=!coverageCardCollapsed">Cancel</button>
          <button nz-button [nzType]="'primary'" (click)="coverageCardCollapsed=!coverageCardCollapsed">Save</button>
        </div>
      </div>
    </div>

  </div>

  <div class="card-container m-b-20">

    <h3 class="card-summary-title"><i nz-icon nzType="user"></i> Agents</h3>

    <div class="card-summary" *ngIf="!agentCardCollapsed">
      <div class="card-summary-content">
        <div class="card-summary-data-grid">
          <div class="card-summary-data">
            <b>Discount Percentage:</b>
            13%
          </div>
          <div class="card-summary-data">
            <b>Commission Percentage:</b>
            12%
          </div>
          <div class="card-summary-data">
            <b>Branch :</b>
            BANDUNG
          </div>
          <div class="card-summary-data">
            <b>Sales PIC:</b>
            MAYAN
          </div>
          <div class="card-summary-data">
            <b>Division:</b>
            Indonesia
          </div>
          <div class="card-summary-data">
            <b>Sub-Division:</b>
            Indonesia-Indonesia
          </div>
        </div>
        <br>
        <nz-list [nzDataSource]="agentdata" [nzRenderItem]="item" [nzGrid]="{gutter: 16, span: 6}">
          <ng-template #item let-item>
            <nz-list-item [nzContent]="nzContent">
              <ng-template #nzContent>
                <nz-card [nzTooltipTitle]="item.title">
                  {{item.name}}
                </nz-card>
              </ng-template>
            </nz-list-item>
          </ng-template>
        </nz-list>
      </div>
      <div class="card-summary-actions">
        <a href="javascript:void(0)" (click)="agentCardCollapsed=!agentCardCollapsed">
          <i nz-icon nzType="edit"></i>
          <!--[ edit ]-->
        </a>
      </div>
    </div>

    <div *ngIf="agentCardCollapsed">
      <div>

        <div class="flexie-auto-grid">
          <div>

            <div class="zero-ui">
              <i nz-icon nzType="user" nzTheme="outline"></i>
              <h2>Add Agents</h2>
              <p>Click here to add agents for this proposal</p>
            </div>


          </div>

        </div>



      </div>
      <div class="card-summary-data-footer">
        <div>
          <button nz-button (click)="agentCardCollapsed=!agentCardCollapsed">Cancel</button>
        </div>
        <div>
          <button nz-button class="b-0 m-r-10" (click)="agentCardCollapsed=!agentCardCollapsed">Cancel</button>
          <button nz-button [nzType]="'primary'" (click)="agentCardCollapsed=!agentCardCollapsed">Save</button>
        </div>
      </div>
    </div>

  </div>



  <!-- Modals -->

  <nz-modal nzWidth="90%" nzWrapClassName="flex-both-center" [(nzVisible)]="isVisibleMiddle" nzTitle="Search Client"
    (nzOnCancel)="handleCancelMiddle()" (nzOnOk)="handleOkMiddle()">
    <ng-container *nzModalContent>
    <nz-table #rowSelectionTable [nzData]="dataTable" (nzCurrentPageDataChange)="currentPageDataChange($event)"
      (nzPageIndexChange)="refreshStatus()" (nzPageSizeChange)="refreshStatus()">
      <thead>
        <tr>
          <th nzShowCheckbox [(nzChecked)]="allChecked" [nzIndeterminate]="indeterminate" (nzCheckedChange)="checkAll($event)"></th>
          <th>Name</th>
          <th>Age</th>
          <th>Address</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of rowSelectionTable.data">
          <td nzShowCheckbox [(nzChecked)]="data.checked" [nzDisabled]="data.disabled" (nzCheckedChange)="refreshStatus()"></td>
          <td>{{data.name}}</td>
          <td>{{data.age}}</td>
          <td>{{data.address}}</td>
        </tr>
      </tbody>
    </nz-table>
    </ng-container>
  </nz-modal>

  <nz-modal nzWidth="80%" nzWrapClassName="flex-both-center" [nzStyle]="{ top: '20px' }" [(nzVisible)]="isClientCaptureModalVisible" nzTitle="Capture New Client"
    (nzOnCancel)="handleClientCaptureCancelMiddle()" (nzOnOk)="handleClientCaptureOkMiddle()">
    <ng-container *nzModalContent>
    <form>
      <div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Product</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                <nz-option nzValue="1" nzLabel="HealthFirst"></nz-option>
                <nz-option nzValue="0" nzLabel="HealthSecond"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Plan</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                <nz-option nzValue="1" nzLabel="Gold"></nz-option>
                <nz-option nzValue="0" nzLabel="Silver"></nz-option>
                <nz-option nzValue="0" nzLabel="Platinum"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <!-- <nz-form-item>
                  <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                      <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                          <nz-option nzValue="1" nzLabel="Protection"></nz-option>
                          <nz-option nzValue="0" nzLabel="Credit Terms"></nz-option>
                      </nz-select>
                  </nz-form-control>
              </nz-form-item> -->
          <div></div>

        </div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Purpose of Insurance</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio nzValue="A">Protection</label>
                <label nz-radio nzValue="B">Credit Terms</label>
                <label nz-radio nzValue="C">Safety and Convinience</label>
                <label nz-radio nzValue="D">Others</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div class="flexie-auto-grid">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Currency</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group nzName="radiogroup" [(ngModel)]="radioValue" name="radiogroup">
                <label nz-radio nzValue="A">USD</label>
                <label nz-radio nzValue="B">INR</label>
                <label nz-radio nzValue="C">IDR</label>
                <label nz-radio nzValue="D">SGD</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>


        <div class="flexie-auto-grid">

          <!-- <nz-form-item>
                <nz-form-label [nzSpan]="24">Currency</nz-form-label>
                <nz-form-control [nzSpan]="24">
                    <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                        <nz-option nzValue="1" nzLabel="USD"></nz-option>
                        <nz-option nzValue="0" nzLabel="INR"></nz-option>
                        <nz-option nzValue="0" nzLabel="IDR"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item> -->

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Inception Date and Expiry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-range-picker name="daterange" [(ngModel)]="dateRange" (ngModelChange)="onChange($event)" nzShowTime></nz-range-picker>
            </nz-form-control>
          </nz-form-item>
          <div></div>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Due Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>



        </div>

        <div class="flexie-auto-grid">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Entry Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Received Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Signed Date</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker name="date" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>

        </div>

      </div>
    </form>
    </ng-container>
  </nz-modal>

</form>
